import {ReactNode} from 'react';

import {Codes} from './Codes';
import {Description} from './Description';
import {UserInfo} from './UserInfo';

type Props = {
  userName: string;
  userPhoneNumber: string;
  userCode: string;
  agentCode: string;
  error?: ReactNode;
  loading?: boolean;
};

export function Details({
  userName,
  userPhoneNumber,
  userCode,
  agentCode,
  error,
  loading,
}: Props) {
  return (
    <>
      <Description />
      <UserInfo userName={userName} userPhoneNumber={userPhoneNumber} />
      <Codes
        userCode={userCode}
        agentCode={agentCode}
        error={error}
        loading={loading}
      />
    </>
  );
}
